/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { AcceptTermsConditions, AcceptTermsConditionsWrapper, ButtonAccountVerifyBox, DateInformationExpired, LoginLogoSpan, ParagraphAccount, ParagraphAccountSuccess, SuccessAccountBox, SuccessExistAccountBox, TitleVerifyAccount, VerfyAccountForm, VerifyAccountBox, VerifyAccountContent, VerifyAccountFormBox, VerifyAccountLabel, VerifyAccountLogo, VerifyAccountTitle, VerifyAccountWrapper } from "./styles";
import { InputCheckbox, InputComponent, LargeButton, TeamLogo, TextboxWarning } from "../../components";
import { useInputValue } from "../../utils/hooks/useInputValue";
import { VerifyAccountForm } from "./verifyAccount.model";
import { useQuery } from "../../utils/helpers/useQuery";
import { Auth as AuthClass } from '../../utils/api/';
import { Utils } from "../../utils/api";
import moment from "moment";
import { ARMcontext } from "../../utils/context/context";

const VerifyAccount = () => {
    const Auth = new AuthClass();
    const query = useQuery();
    let history = useHistory();
    const {HandleToastMessage} = useContext(ARMcontext);

    const [successResponse, setSuccessResponse] = useState<{
        success: boolean,
        exist: boolean
    }>({
        success: false,
        exist: false
    });

    const [cacheDataForm, setCacheDataForm] = useState<VerifyAccountForm>({
        ...new VerifyAccountForm(),
        email: query.get('email') as string
    });
    const [isLoading, setIsLoasing] = useState<boolean>(false);
    const [messageExistObject, setMessageExistObject] = useState<{firstPart: string, secondPart: string}>({firstPart: '', secondPart: ''})

    const extract = ([beg, end]) =>  {
        const matcher = new RegExp(`${beg}(.*?)${end}`,'gm');
        const normalise = (str) => str.slice(beg.length,end.length*-1);
        return (str) => {
            return str.match(matcher).map(normalise) as Array<string>;
        }
    }

    const onSubmit = useCallback(async ({payload, overwrite}: {payload: VerifyAccountForm, overwrite?: boolean}) => {
        setCacheDataForm(payload);
        const token = query.get('token') as string;
        setIsLoasing(true)
        try {
            const response = await Auth.verifyAccount({
                token: token,
                email: payload.email,
                confirmationEmail: payload.confirmEmail,
                firstName: payload.firstName,
                lastName: payload.lastName,
                password: payload.password,
                passwordConfirmation: payload.confirmPassword,
                ...(overwrite ? {overwrite: true} : {})
            });
            
            if(response.status && response?.statusCode === 202) {
                setSuccessResponse({success: true, exist: true})
                const messageSplited = response.message?.split('|') ?? [];
                const firstPart = `${messageSplited[0]} ${messageSplited.length >= 3 ? messageSplited[1].trimStart() : ''}`;
                const stringStractor = extract(['<span>', '</span>']);
                const _secondPart = `${messageSplited[messageSplited.length-1].trimStart()}`;
                const date = stringStractor(_secondPart);
                const secondPartReplaced = _secondPart.replace(`<span>${date.at(0)}</span>`, `<span>${moment(date.at(0)).format('DD/MM/YYYY')}</span>`);
                setMessageExistObject({firstPart, secondPart: secondPartReplaced});
                
            } else if (!response.status) {
                HandleToastMessage(response.message ?? 'An error ocurred while updating status account.', true, 2000, 'error');
            } else {
                setSuccessResponse({success: true, exist: false})
            }
        } catch (error) {
            HandleToastMessage('An error ocurred while updating status account.', true, 2000, 'error');
        } finally {
            setIsLoasing(false)
        }

    }, [cacheDataForm, messageExistObject])

    useEffect(() => {
        
        const token = query.get('token') as string;
        const email = query.get('email') as string;
        if (!(email && token)) {
            history.replace('/')
        }
    }, [])

    return (
        <VerifyAccountWrapper>
            <VerifyAccountBox>
                <VerifyAccountLogo>
                    <TeamLogo mWidth="200px" mHeight="40px" />
                    <LoginLogoSpan>Measure. Monitor. Optimize</LoginLogoSpan>
                </VerifyAccountLogo>
                <VerifyAccountContent>
                    {
                        successResponse.exist && successResponse.success ? 
                            (
                                <SuccessExistAcountView 
                                    messageExistObject={messageExistObject}
                                    dataForm={new VerifyAccountForm(cacheDataForm)} isLoading={isLoading} onAction={(action) => {
                                        if (action === 'back') {
                                            setSuccessResponse({
                                                success: false, 
                                                exist: false
                                            })
                                        } else if (action === 'continue') {
                                            onSubmit({payload: cacheDataForm, overwrite: true})
                                        }
                                }} />
                            ) 
                            : 
                        successResponse.success  && !successResponse.exist ? 
                            (
                                <SuccessAcountView dataForm={new VerifyAccountForm(cacheDataForm)} />
                            )
                            : 
                            (
                                <FormVerifyAccount dataForm={new VerifyAccountForm(cacheDataForm)} isLoading={isLoading} onSubmitForm={(data) => {
                                    onSubmit({
                                        payload: data
                                    })
                                }} />
                            )
                    }
                    
                </VerifyAccountContent>
            </VerifyAccountBox>
        </VerifyAccountWrapper>
    )
}

const FormVerifyAccount = ({
    dataForm,
    onSubmitForm,
    isLoading
}: {
    dataForm?: VerifyAccountForm,
    onSubmitForm: (data: any) => void,
    isLoading: boolean
}) => {
    

    const utils = new Utils();
    const isValidEmail = utils.GetValidationEmailPattern();
    
    const [termsConditionControl, setTermsConditionsControl] = useState(dataForm?.termsCondition ?? false)
    const firstNameControl = useInputValue(dataForm?.firstName ?? '');
    const lastNameControl = useInputValue(dataForm?.lastName ?? '');
    const emailControl = useInputValue(dataForm?.email ?? '');
    const confirmEmailControl = useInputValue(dataForm?.confirmEmail ?? '');
    const passwordControl = useInputValue(dataForm?.password ?? '', 'eyeClose', '', '', 'password');
    const confirmPasswordControl = useInputValue(dataForm?.confirmPassword ?? '', 'eyeClose', '', '', 'password');
    

    const HandleFocus = () => {
        let inputs = [firstNameControl, lastNameControl, emailControl, confirmEmailControl, passwordControl, confirmPasswordControl];
        inputs.forEach(input => {
            input.HandleWarning('');
            input.HandleStatus('normal');
        })
    }

    const HandleIcon = (hook: any) => {
        if (hook.icon === 'eyeClose') {
          hook.HandleIcon('eyeOpen');
          hook.HandleType('text');
        } else if (hook.icon === 'eyeOpen') {
          hook.HandleIcon('eyeClose');
          hook.HandleType('password');
        }
    }

    const checkEmailAndPasswords = () => {
        let error = true;
        if (!Boolean(isValidEmail.test(emailControl.value))) {
            emailControl.HandleWarningTitle('Incorrect email');
            emailControl.HandleWarning('Please enter a valid email');
            emailControl.HandleStatus('error');
        } else if (!(emailControl.value === confirmEmailControl.value)) {
            confirmPasswordControl.HandleWarningTitle('Check the emails');
            confirmPasswordControl.HandleWarning('Emails are not the same');
            confirmPasswordControl.HandleStatus('error');
        }  else if (!(passwordControl.value === confirmPasswordControl.value)) {
            confirmPasswordControl.HandleWarningTitle('Check the passwords');
            confirmPasswordControl.HandleWarning('Passwords are not the same');
            confirmPasswordControl.HandleStatus('error');
        } else {
            error = false;
        }

        return error;
    }

    const isValid = () => {
        // at first validate required values
        const required = !!firstNameControl.value 
            && !!lastNameControl.value 
            && !!emailControl.value 
            && !!confirmEmailControl.value  
            && !!passwordControl.value 
            && !!confirmPasswordControl.value 
            && termsConditionControl;
        return required;
    }

    const onSubmit = () => {
        const isValidEmails = !checkEmailAndPasswords()
        if (isValidEmails) {
            const payload: VerifyAccountForm = new VerifyAccountForm({
                firstName: firstNameControl.value,
                lastName: lastNameControl.value,
                email: emailControl.value,
                confirmEmail: confirmEmailControl.value,
                password: passwordControl.value,
                confirmPassword: confirmPasswordControl.value,
                termsCondition: termsConditionControl
            })
            onSubmitForm(payload)
        }
    }

    return (
        <VerifyAccountFormBox>
            <VerifyAccountTitle>Account Details</VerifyAccountTitle>
            <VerfyAccountForm>
                <div>
                    <VerifyAccountLabel>First Name</VerifyAccountLabel>
                    <InputComponent
                        fontSize={16}
                        disabled={false}
                        bordeRadius={'4px'}
                        inputStyle={'dark'}
                        insetShadow="#F4F5F7"
                        dynamicSearch={firstNameControl}
                        placeholder="Player's first name"
                        backgroundColor={'#F4F5F7'}
                        colorPlaceholder={'#D8DDE3'}
                        HandleFocus={() => HandleFocus()}
                    />
                </div>
                <div>
                    <VerifyAccountLabel>Last Name</VerifyAccountLabel>
                    <InputComponent
                        fontSize={16}
                        disabled={false}
                        bordeRadius={'4px'}
                        inputStyle={'dark'}
                        insetShadow="#F4F5F7"
                        dynamicSearch={lastNameControl}
                        placeholder="Player's last name"
                        backgroundColor={'#F4F5F7'}
                        colorPlaceholder={'#D8DDE3'}
                        HandleFocus={() => HandleFocus()}
                    />
                </div>
                <div>
                    <VerifyAccountLabel>Player Email</VerifyAccountLabel>
                    <InputComponent
                        fontSize={16}
                        disabled={false}
                        bordeRadius={'4px'}
                        inputStyle={'dark'}
                        insetShadow="#F4F5F7"
                        dynamicSearch={emailControl}
                        placeholder="example@domain.com"
                        backgroundColor={'#F4F5F7'}
                        colorPlaceholder={'#D8DDE3'}
                        HandleFocus={() => HandleFocus()}
                    />
                    <TextboxWarning status={emailControl.status} title={emailControl.warningTitle} message={emailControl.warningMessage}/>
                </div>
                <div>
                    <VerifyAccountLabel>Confirm Player Email</VerifyAccountLabel>
                    <InputComponent
                        fontSize={16}
                        disabled={false}
                        bordeRadius={'4px'}
                        inputStyle={'dark'}
                        insetShadow="#F4F5F7"
                        dynamicSearch={confirmEmailControl}
                        placeholder="Repeat your email"
                        backgroundColor={'#F4F5F7'}
                        colorPlaceholder={'#D8DDE3'}
                        HandleFocus={() => HandleFocus()}
                    />
                    <TextboxWarning status={confirmPasswordControl.status} title={confirmPasswordControl.warningTitle} message={confirmPasswordControl.warningMessage}/>
                </div>
                <div>
                    <VerifyAccountLabel>Password</VerifyAccountLabel>
                    <InputComponent
                        fontSize={16}
                        disabled={false}
                        bordeRadius={'4px'}
                        inputStyle={'dark'}
                        insetShadow="#F4F5F7"
                        dynamicSearch={passwordControl}
                        placeholder="Create password"
                        backgroundColor={'#F4F5F7'}
                        colorPlaceholder={'#D8DDE3'}
                        HandleIcon={() => HandleIcon(passwordControl)}
                        HandleFocus={() => HandleFocus()}
                    />
                </div>
                <div>
                    <VerifyAccountLabel>Confirm Pasword</VerifyAccountLabel>
                    <InputComponent
                        fontSize={16}
                        disabled={false}
                        bordeRadius={'4px'}
                        inputStyle={'dark'}
                        insetShadow="#F4F5F7"
                        dynamicSearch={confirmPasswordControl}
                        placeholder="Confirm your password"
                        backgroundColor={'#F4F5F7'}
                        colorPlaceholder={'#D8DDE3'}
                        HandleIcon={() => HandleIcon(confirmPasswordControl)}
                        HandleFocus={() => HandleFocus()}
                    />
                </div>
            </VerfyAccountForm>
            <AcceptTermsConditionsWrapper>
                <InputCheckbox id="termsConditions" checked={termsConditionControl} onClick={() => setTermsConditionsControl(!termsConditionControl)} />
                <AcceptTermsConditions htmlFor="termsConditions">
                    By creating an account you agree to our <a href="https://armcare.com/pages/terms-and-conditions-of-participation" rel="noopener noreferrer" target="_blank">Terms of Service Conditions</a> and <a href="https://armcare.com/pages/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a>
                </AcceptTermsConditions>
            </AcceptTermsConditionsWrapper>
            <LargeButton
                fullWidth
                lMargin="0"
                fSize={'16px'}
                bradius={'8px'}
                rColor="#017CFF"
                bColor="#FFFFFF"
                disabled={!isValid() || isLoading}
                xMargin={'5vh 0 0;'}
                title={!isValid() ? 'Please fill all the fields' : isLoading ? 'Loading' : 'Continue'}
                callback={onSubmit}
                colorDisabled={'#F4F5F7'}
                fColor={(!isValid() || isLoading) ? "#607184" : ''}
                fWeight={ (!isValid() || isLoading) ? '400' : '700'}
            />
        </VerifyAccountFormBox>
    )
}


const SuccessExistAcountView = ({
    dataForm,
    onAction,
    isLoading,
    messageExistObject
}: {
    dataForm?: VerifyAccountForm,
    onAction: (action: 'back' | 'continue') =>  void
    isLoading?: boolean,
    messageExistObject: {firstPart: string, secondPart: string}
}) => {

    return (
        <SuccessExistAccountBox>
            <TitleVerifyAccount>ArmCare Active Subscription Alert</TitleVerifyAccount>
            <ParagraphAccount dangerouslySetInnerHTML={{__html: messageExistObject.firstPart}}>
            </ParagraphAccount>
            <DateInformationExpired dangerouslySetInnerHTML={{__html: messageExistObject.secondPart}}>
            </DateInformationExpired>
            <ButtonAccountVerifyBox>
                <LargeButton
                    lMargin="0"
                    fSize={'16px'}
                    bradius={'8px'}
                    rColor="#FFFFFF"
                    bColor="#017CFF"
                    xMargin={'5vh 0 0;'}
                    title={'Use a Different Email'}
                    disabled={isLoading}
                    callback={()=>{
                        onAction('back')
                    }}
                    colorDisabled={'#F4F5F7'}
                    fColor="#017CFF"
                />

                <LargeButton
                    lMargin="0"
                    fSize={'16px'}
                    bradius={'8px'}
                    rColor="#017CFF"
                    bColor="#FFFFFF"
                    xMargin={'5vh 0 0;'}
                    title={'Apply and Overwrite'}
                    callback={()=>{
                        onAction('continue')
                    }}
                    colorDisabled={'#F4F5F7'}
                    
                />
            </ButtonAccountVerifyBox>
        </SuccessExistAccountBox>
    );
}

const SuccessAcountView = (
    {
        dataForm
    }
    :
    {
        dataForm?: VerifyAccountForm,
    }
) => {

    return (
        <SuccessAccountBox>
            <TitleVerifyAccount>Congratulations!</TitleVerifyAccount>
            <ParagraphAccountSuccess>Your subscription was successfully applied to <br/><span id="success-only">{dataForm?.email}</span></ParagraphAccountSuccess>
        </SuccessAccountBox>
    );
}

export default VerifyAccount;